module.exports = __webpack_public_path__ + "static/media/hair10.9261255e.png";